import * as API from './';

/******************************  hotel  *******************************/
// 查询酒店
export const GetBusinessHotelList = data => API.GET(`/api/business/hotel/list`, data, true)
// 获取酒店二维码(普通)
export const GetBusinessHotelUnionCode = hotelId => API.GET(`/api/business/hotel/union/code/${hotelId}`, true)
// 分页查询酒店会员
export const GetBusinessHotelMemberPage = data => API.GET(`/api/business/hotel/member/page`, data, true)
// 查询酒店会员等级
export const GetBusinessHotelMemberLevelByhotel = hotelId => API.GET(`/api/business/hotel/member/level/byhotel/${hotelId}`, true)
// 编辑酒店会员-个人信息
export const PostBusinessHotelMemberEdit = data => API.POST(`/api/business/hotel/member/edit`, data, true)
// 新增酒店会员等级
export const PostBusinessHotelMemberLevelAdd = data => API.POST(`/api/business/hotel/member/level/add`, data, true)
// 编辑酒店会员等级
export const PostBusinessHotelMemberLevelEdit = data => API.POST(`/api/business/hotel/member/level/edit`, data, true)
// 删除酒店会员等级
export const PostBusinessHotelMemberLevelRemove = hotelMemberLevelId => API.POST(`/api/business/hotel/member/level/remove/${hotelMemberLevelId}`, true)
// 一键新增酒店会员等级
export const PostBusinessHotelMemberLevelAddByhotel = hotelId => API.POST(`/api/business/hotel/member/level/add/byhotel/${hotelId}`, true)
// 根据角色获取酒店员工列表
export const GetBusinessHotelOpRelationRoleByhotel = (hotelId,data) => API.GET(`/api/business/hotel/op/relation/role/byhotel/${hotelId}`, data, true)
// 查询酒店二级商户
export const GetBusinessHotelMerchantByhotel = (hotelId,data) => API.GET(`/api/business/hotel/merchant/byhotel/${hotelId}`, data, true)
// 新增酒店二级商户
export const PostBusinessHotelMerchantAdd = data => API.POST(`/api/business/hotel/merchant/add`, data, true)
// 编辑酒店二级商户
export const PostBusinessHotelMerchantEdit = data => API.POST(`/api/business/hotel/merchant/edit`, data, true)
// 根据ID查询二级商户
export const GetBusinessHotelMerchant = (hotelMerchantId,data) => API.GET(`/api/business/hotel/merchant/${hotelMerchantId}`, data, true)

/******************************  roomscale  *******************************/
// 同步订单-通过酒店ID查找房型(房价)
export const GetBusinessRoomscaleByhotel = hotelId => API.GET(`/api/business/roomscale/byhotel/${hotelId}`, true)
// 同根据id查询基础房型信息
export const GetBusinessRoomscale = roomScaleId => API.GET(`/api/business/roomscale/${roomScaleId}`, true)
// 同步订单-通过酒店ID查找房型-添加基础房型剩余房间数量
export const GetBusinessRoomscaleStateByhotel = (hotelId,data) => API.GET(`/api/business/roomscale/state/byhotel/${hotelId}`, data, true)
// 房态管理-修改房量-单天
export const PostBusinessRoomscaleStateEdit = data => API.POST(`/api/business/roomscale/state/edit`, data, true)
// 查询房型连住折扣详细信息
export const GetBusinessRoomscaleDiscountInfo = roomScaleDiscountId => API.GET(`/api/business/roomscale/discount/info/${roomScaleDiscountId}`, true)
// 手动分房根据酒店获取基础房型信息
export const GetBusinessRoomscaleHandleRoomByhotel = (hotelId,data) => API.GET(`/api/business/roomscale/handle/room/byhotel/${hotelId}`, data, true)
// 长租折扣查询
export const GetBusinessRoomscaleDiscount = roomScaleId => API.GET(`/api/business/roomscale/discount/${roomScaleId}`, true)
// 长租折扣新增
export const PostBusinessRoomscaleDiscountAdd = data => API.POST(`/api/business/roomscale/discount/add`, data, true)
// 长租折扣删除
export const PostBusinessRoomscaleDiscountRemove = roomScaleDiscountId => API.POST(`/api/business/roomscale/discount/remove/${roomScaleDiscountId}`, true)
// 根据酒店获取长短租基础房型及房态
export const GetBusinessRoomscaleMonthState = data => API.GET(`/api/business/roomscale/month/state`, data, true)

/******************************  virtual  *******************************/
// 产品房型
export const GetBusinessVirtualRoomscaleList = data => API.GET(`/api/business/virtual/roomscale/list`, data, true)
// 添加产品房型
export const PostBusinessVirtualRoomscaleAdd = data => API.POST(`/api/business/virtual/roomscale/add`, data, true)
// 编辑产品房型
export const PostBusinessVirtualRoomscaleEdit = data => API.POST(`/api/business/virtual/roomscale/edit`, data, true)
// 产品房型-关
export const PostBusinessVirtualRoomscaleOn = virtualRoomScaleId => API.POST(`/api/business/virtual/roomscale/on/${virtualRoomScaleId}`, true)
// 产品房型-开
export const PostBusinessVirtualRoomscaleOff = virtualRoomScaleId => API.POST(`/api/business/virtual/roomscale/off/${virtualRoomScaleId}`, true)
// 查询产品房型信息
export const GetBusinessVirtualRoomscale = virtualRoomScaleId => API.GET(`/api/business/virtual/roomscale/${virtualRoomScaleId}`, true)
// 房价管理-查询产品房型
export const GetBusinessVirtualRoomscaleDaypriceByroomscale = roomScaleId => API.GET(`/api/business/virtual/roomscale/dayprice/byroomscale/${roomScaleId}`, true)
// 同步订单-根据入住天日期取产品房型房价
export const GetBusinessVirtualRoomscaleDaypriceDate = (virtualRoomScaleId,data) => API.GET(`/api/business/virtual/roomscale/dayprice/date/${virtualRoomScaleId}`, data, true)
// 房型管理-删除产品房型
export const PostBusinessVirtualRoomscaleRemove = virtualRoomScaleId => API.POST(`/api/business/virtual/roomscale/remove/${virtualRoomScaleId}`, true)
// 根据基础房型获取产品房型信息以及及时房态
export const GetBusinessVirtualRoomscaleNowStateByroomscale = (roomScaleId,data) => API.GET(`/api/business/virtual/roomscale/now/state/byroomscale/${roomScaleId}`, data, true)
// 订单同步-查询产品房型
export const GetBusinessVirtualRoomscaleStateByroomscale = (roomScaleId,data) => API.GET(`/api/business/virtual/roomscale/state/byroomscale/${roomScaleId}`, data, true)
// 根据基础房型和类型获取产品房型信息
export const GetBusinessvirtualRoomscaleScaleTypeByRoomScale = data => API.GET(`/api/business/virtual/roomscale/scaleType/byRoomScale`, data, true)


/******************************  roomstate  *******************************/
// 查询酒店所有房型房态
export const GetBusinessRoomstateBookByhotel = (hotelId,data) => API.GET(`/api/business/roomstate/book/byhotel/${hotelId}`, data, true)
// 查询酒店所有房型房态房价
export const GetBusinessRoomstatePriceBookByhotel = (hotelId,data) => API.GET(`/api/business/roomstate/price/book/byhotel/${hotelId}`, data, true)
// 查询产品房型房态房价
export const GetBusinessRoomstatePriceBookVirtual = (virtualRoomScaleId,data) => API.GET(`/api/business/roomstate/price/book/virtual/${virtualRoomScaleId}`, data, true)



/******************************  orderroom  *******************************/
// 换房申请
export const PostBusinessOrderroomRoomchange = (orderRoomId,data) => API.POST(`/api/business/orderroom/roomchange/${orderRoomId}`, data, true)
// 根据订单房间id查询详情信息
export const GetBusinessOrderroom = orderRoomId => API.GET(`/api/business/orderroom/${orderRoomId}`, true)
// 根据用户和酒店查询入住记录
export const PostBusinessOrderroomUserRecord = data => API.POST(`/api/business/orderroom/user/record`, data, true)
// 根据房间查询订单详细信息
export const GetBusinessOrderroomByroom = roomId => API.GET(`/api/business/orderroom/byroom/${roomId}`, true)
// 分页获取订单房间列表
export const PostBusinessOrderroomList = data => API.POST(`/api/business/orderroom/list`, data, true)
// 根据房间查历史记录
export const GetBusinessOrderroomHistoryByroom = data => API.GET(`/api/business/orderroom/history/byroom`, data, true)
// 根据订单房间id查询结算信息
export const GetBusinessOrderroomSumBill = orderRoomId => API.GET(`/api/business/orderroom/sum/bill/${orderRoomId}`, true)
// 查询未办理的订单房间
export const PostBusinessOrderroomUnroomList = data => API.POST(`/api/business/orderroom/unroom/list`, data, true)
// 订单重新下发密码
export const PostBusinessOrderroomPasswordSend = (orderRoomId,data) => API.POST(`/api/business/orderroom/password/send/${orderRoomId}`, data, true)
// 订单取消
export const PostBusinessOrderroomCancel = (orderRoomId,data) => API.POST(`/api/business/orderroom/cancel/${orderRoomId}`, data, true)
// 扣除押金：(清洁中)
export const PostBusinessOrderroomDepositCut = (orderRoomId,data) => API.POST(`/api/business/orderroom/deposit/cut/${orderRoomId}`, data, true)
// 房东优惠
export const PostBusinessOrderroomRefuseLandlord = (orderRoomId,data) => API.POST(`/api/business/orderroom/refuse/landlord/${orderRoomId}`, data, true)
// 订单房间重新发送短信
export const PostBusinessOrderroomSendMessageAgain = (orderRoomId,data) => API.POST(`/api/business/orderroom/send/message/again/${orderRoomId}`,data, true)
// 根据id查
export const GetBusinessOrderroomByorder = orderId => API.GET(`/api/business/orderroom/byorder/${orderId}`, true)
// 开启无证入住
export const PostBusinessOrderroomNocardOn = (orderRoomId,data) => API.POST(`/api/business/orderroom/nocard/on/${orderRoomId}`, data, true)
// 房东办理入住
export const PostBusinessOrderroomRoomin = (orderRoomId,data) => API.POST(`/api/business/orderroom/roomin/${orderRoomId}`, data, true)
// 日租-开启/关闭延时退房
export const PostBusinessOrderroomDelaySwitchOn = (orderRoomId,data) => API.POST(`/api/business/orderroom/delay/switch/on/${orderRoomId}`, data, true)
// 开启-自动扣押延时退房
export const PostBusinessOrderroomAutoDetainOn = (orderRoomId,data) => API.POST(`/api/business/orderroom/auto/detain/on/${orderRoomId}`, data, true)
// 关闭-自动扣押延时退房
export const PostBusinessOrderroomAutoDetainOff = (orderRoomId,data) => API.POST(`/api/business/orderroom/auto/detain/off/${orderRoomId}`, data, true)
// 房东换房型（未办理入住）
export const PostBusinessOrderroomRoomscaleChange = (orderRoomId,data) => API.POST(`/api/business/orderroom/roomscale/change/${orderRoomId}`, data, true)
// 退租-获取退房详细信息
export const GetBusinessOrderroomLeaveinfo = orderRoomId => API.GET(`/api/business/orderroom/leaveinfo/${orderRoomId}`, true)
// 订单房间退房-长租-合并（全部退房）
export const PostBusinessOrderroomLeave = data => API.POST(`/api/business/orderroom/leave`, data, true)
// 房东换表
export const PostBusinessOrderroomMeterChange = (orderRoomId,data) => API.POST(`/api/business/orderroom/meter/change/${orderRoomId}`, data, true)
// 订单房间冲账_最新版
export const PostBusinessOrderroomReverse = data => API.POST(`/api/business/orderroom/reverse/${data.orderRoomId}`, data, true)
// 订单押金扣押冲账
export const PostBusinessOrderroomDepositReverseLandlord = (orderRoomId,data) => API.POST(`/api/business/orderroom/deposit/reverse/landlord/${orderRoomId}`, data, true)
// 修改订单联系人
export const PostBusinessOrderroomUserM = data => API.POST(`/api/business/orderroom/user/m`, data, true)
// 订单房间修改车牌号码
export const PostBusinessOrderroomCar = (orderRoomId,data) => API.POST(`/api/business/orderroom/car/${orderRoomId}`, data, true)

// 订单续住 前置条件：已入住,未续住,日租房 ====>  res.data.status == '1' && res.data.isCon == 0 && res.data.orderType == '1'
export const PostBusinessOrderRoomContinue = (data) => API.POST(`/api/business/order/con`, data, true)




/******************************  order  *******************************/
// 散客-手动分房
export const PostBusinessOrderHandleRoom = data => API.POST(`/api/business/order/handle/room`, data, true)
// 根据订单房间查询操作记录
export const GetBusinessOrderOperLogByorderroom = orderRoomId => API.GET(`/api/business/order/oper/log/byorderroom/${orderRoomId}`, true)
// 订单同步
export const PostBusinessOrderExternalSyn = data => API.POST(`/api/business/order/external/syn`, data, true)
// 办理入住
export const PostBusinessOrderRoomin = (orderId,data) => API.POST(`/api/business/order/roomin/${orderId}`,data, true)
// 订单线下支付
export const PostBusinessOrderOfflinePay = (orderId,data) => API.POST(`/api/business/order/offline/pay/${orderId}`, data, true)
// 获取手动分房付款二维码
export const GetBusinessOrderPayCode = orderId => API.GET(`/api/business/order/pay/code/${orderId}`, true)
// 手动分房-根据id获取订单
export const GetBusinessOrder = orderId => API.GET(`/api/business/order/${orderId}`, true)


/******************************  orderroomuser  *******************************/
// 根据条件查询酒店入住人信息
export const GetBusinessOrderroomuserQuery = data => API.GET(`/api/business/orderroomuser/query`, data, true)
// 导出入住人信息
export const PostBusinessOrderroomuserExport = data => API.POST(`/api/business/orderroomuser/export`, data, true)
// 添加入住人
export const PostBusinessOrderroomuserAdd = data => API.POST(`/api/business/orderroomuser/add`, data, true)
// 查询房间入住人信息
export const GetBusinessOrderroomuserByorderroom = orderRoomId => API.GET(`/api/business/orderroomuser/byorderroom/${orderRoomId}`, true)
// 删除入住人信息
export const PostBusinessOrderroomuserRemove = orderRoomUserId => API.POST(`/api/business/orderroomuser/remove/${orderRoomUserId}`, true)


/******************************  user  *******************************/
// 根据用户查询酒店优惠券
export const GetBusinessUserCouponByuser = data => API.GET(`/api/business/user/coupon/byuser`, data, true)
// 新增用户优惠券
export const PostBusinessUserCouponAdd = data => API.POST(`/api/business/user/coupon/add`, data, true)
// 批量新增优惠券
export const PostBusinessUserCouponBatchAdd = data => API.POST(`/api/business/user/coupon/batch/add`, data, true)


/******************************  member  *******************************/
// 查询会员等级模板
export const GetBusinessMemberLevelTemplateAll = data => API.GET(`/api/business/member/level/template/all`, data, true)


/******************************  roomprice  *******************************/
// 房价管理-查询产品房型日历价格
export const GetBusinessRoompriceBook = (virtualRoomScaleId,data) => API.GET(`/api/business/roomprice/book/${virtualRoomScaleId}`, data, true)
// 房价管理-新增或修改(单天)
export const PostBusinessRoompriceEdit = data => API.POST(`/api/business/roomprice/edit`, data, true)
// 房价管理-新增或修改（时间段）
export const PostBusinessRoompriceBatchAdd = data => API.POST(`/api/business/roomprice/batch/add`, data, true)


/******************************  account  *******************************/
// 新增交账或充值备用金
export const PostBusinessAccountRecordAdd = data => API.POST(`/api/business/account/record/add`, data, true)
// 根据酒店和类型查询交账记录
export const GetBusinessAccountRecordByhotel = (hotelId,data) => API.GET(`/api/business/account/record/byhotel/${hotelId}`, data, true)
// 查询付款二维码
export const GetBusinessAccountUnitQrPay = data => API.GET(`/api/business/account/unit/qr/pay`, data, true)


/******************************  bill  *******************************/
// 根据账单查询明细
export const GetBusinessBillRecordSumByBillRecord = billRecordId => API.GET(`/api/business/bill/record/sum/byBillRecord/${billRecordId}`, true)
// 根据类型查询账单明细
export const GetBusinessBillRecordListByType = data => API.GET(`/api/business/bill/record/list/byType`, data, true)
// 查询酒店未出账账单明细
export const GetBusinessBillRecordNoPaidByhotel = hotelId => API.GET(`/api/business/bill/record/no/paid/byhotel/${hotelId}`, true)
// 账单管理-查询账单列表
export const GetBusinessBillRecord = (hotelId,data) => API.GET(`/api/business/bill/record/${hotelId}`, data, true)
// 账单管理-账单转账失败
export const GetBusinessBillRecordTransfer = billRecordId => API.GET(`/api/business/bill/record/transfer/${billRecordId}`, true)
// 查询日期账单明细
export const GetBusinessBillRecordList = id => API.GET(`/api/business/bill/record/list/${id}`, true)
// 查询平台账单信息
export const GetBusinessBillRecordAll = data => API.GET(`/api/business/bill/record/all`, data, true)
// 查询---平台账单明细
export const GetBusinessBillRecordSumDetailAll = data => API.GET(`/api/business/bill/record/sum/detail/all`, data, true)
// 查询平台--未出账账单明细
export const GetBusinessBillRecordNoPaidAll = () => API.GET(`/api/business/bill/record/no/paid/all`, true)


/******************************  life  *******************************/
// 查询酒店查询所有未支付未提交的生活账单
export const GetBusinessLifeCostBillUnpayByhotel = hotelId => API.GET(`/api/business/life/cost/bill/unpay/byhotel/${hotelId}`, true)
// 编辑生活账单起始读数
export const PostBusinessLifeCostBillOriginEdit = data => API.POST(`/api/business/life/cost/bill/origin/edit`, data, true)
// 撤回生活账单
export const PostBusinessLifeCostBillRecall = lifeCostBillId => API.POST(`/api/business/life/cost/bill/recall/${lifeCostBillId}`, true)
// 生活账单线下支付
export const PostBusinessLifeCostBillPayOffline = (lifeCostBillId,data) => API.POST(`/api/business/life/cost/bill/pay/offline/${lifeCostBillId}`, data, true)
// 集中抄表-查询长租房间信息
export const GetBusinessLifeCostBillBatchByhotel = data => API.GET(`/api/business/life/cost/bill/batch/byhotel/${data.hotelId}`,data, true)
// 集中抄表-提交水，电，气
export const PostBusinessLifeCostBillBatchDegreeAdd = data => API.POST(`/api/business/life/cost/bill/batch/degree/add`, data, true)
// 集中抄表-根据id查询生活账单信息
export const GetBusinessLifeCostBill = lifeCostBillId => API.GET(`/api/business/life/cost/bill/${lifeCostBillId}`, true)
// 长租-根据订单房间查询生活账单信息
export const GetBusinessLifeCostBillByorderroom = orderRoomId => API.GET(`/api/business/life/cost/bill/byorderroom/${orderRoomId}`, true)
// 长租-新增生活账单
export const PostBusinessLifeCostBillAdd = data => API.POST(`/api/business/life/cost/bill/add`, data, true)
// 长租-编辑生活账单
export const PostBusinessLifeCostBillEdit = data => API.POST(`/api/business/life/cost/bill/edit`, data, true)
// 长租-新增生活账单-查询最近账单情况
export const GetBusinessLifeCostBillLastByorderroom = orderRoomId => API.GET(`/api/business/life/cost/bill/last/byorderroom/${orderRoomId}`, true)
// 长租-生活账单-换房记录
export const GetBusinessLifeCostRoomRecordByLifeCostBill = lifeCostBillId => API.GET(`/api/business/life/cost/room/record/byLifeCostBill/${lifeCostBillId}`, true)
// 生活账单新增项目
export const PostBusinessLifeCostBillCheckTypeAdd = (lifeCostBillId,data) => API.POST(`/api/business/life/cost/bill/checkType/add/${lifeCostBillId}`, data, true)
// 生活账单移除项目
export const PostBusinessLifeCostBillCheckTypeRemove = (lifeCostBillId,data) => API.POST(`/api/business/life/cost/bill/checkType/remove/${lifeCostBillId}`, data, true)
// 删除生活账单
export const PostBusinessLifeCostBillRemove = (lifeCostBillId,data) => API.POST(`/api//business/life/cost/bill/remove/${lifeCostBillId}`, data, true)
// 单位生活费用导出
export const PostBusinessLifeCostBillCooperExport = data => API.POST(`/api/business/life/cost/bill/cooper/export`, data, true)

/******************************  rental  *******************************/
// 根据酒店查询所有未支付的房费账单
export const GetBusinessRentalBillUnpayByhotel = hotelId => API.GET(`/api/business/rental/bill/unpay/byhotel/${hotelId}`, true)
// 房费账单线下支付
export const PostBusinessRentalBillUnpayByhotel = (rentalBillId,data) => API.POST(`/api/business/rental/bill/pay/offline/${rentalBillId}`, data, true)
// 长租-根据订单房间查询账单信息
export const GetBusinessRentalBillByorderroom = orderRoomId => API.GET(`/api/business/rental/bill/byorderroom/${orderRoomId}`, true)
// 长租-编辑房费账单
export const PostBusinessRentalBillEdit = data => API.POST(`/api/business/rental/bill/edit`, data, true)
// 集中抄表-根据id查询房费账单信息
export const GetBusinessRentalBill = rentalBillId => API.GET(`/api/business/rental/bill/${rentalBillId}`, true)


/******************************  elec  *******************************/
// 根据订单房间查询电费充值账单
export const GetBusinessElecBillByorderroom = orderRoomId => API.GET(`/api/business/elec/bill/byorderroom/${orderRoomId}`, true)
// 根据订单房间查询当前剩余读数
export const GetBusinessElecBillSurplusByorderroom = orderRoomId => API.GET(`/api/business/elec/bill/surplus/byorderroom/${orderRoomId}`, true)
//   根据订单房间查询电表报表
export const GetBusinessElecBillReportByorderroom = (orderRoomId,data) => API.GET(`/api/business/elec/bill/report/byorderroom/${orderRoomId}`, data, true)


/******************************  room  *******************************/
// 根据条件查询房间
export const GetBusinessRoom = data => API.GET(`/api/business/room`, data, true)
// 根据id查询房间信息
export const GetBusinessRoomRoomId = roomId => API.GET(`/api/business/room/${roomId}`, true)
// 绑定房间到基础房型
export const PostBusinessRoomBondByRoomScale = data => API.POST(`/api/business/room/bond/byRoomScale`, data, true)
// 根据酒店id查询所有房间列表
export const GetBusinessRoombyhotelHotelId = hotelId => API.GET(`/api/business/room/byhotel/${hotelId}`, true)
// 根据过滤条件查询房间
export const GetBusinessRoombyhotel = data => API.GET(`/api/business/room/byhotel`, data, true)
// 锁房
export const PostBusinessRoomLock = roomId => API.POST(`/api/business/room/lock/${roomId}`, true)
// 上线
export const PostBusinessRoomOnline = roomId => API.POST(`/api/business/room/online/${roomId}`, true)
// 房间清洁上线
export const PostBusinessRoomCleanUp = cleanOrderId => API.POST(`/api/business/room/clean/up/${cleanOrderId}`, true)
// 日租查询空余房间数量
export const GetBusinessRoomFreeNum = (roomScaleId,data) => API.GET(`/api/business/room/free/num/${roomScaleId}`, data, true)
// 房间查房
export const PostBusinessRoomCleanCheck = (cleanOrderId,data) => API.POST(`/api/business/room/clean/check/${cleanOrderId}`, data, true)
// 查询房间离线密码
export const GetBusinessRoomOfflinePassword = roomId => API.GET(`/api/business/room/offline/password/${roomId}`, true)
// 根据产品房型查询当前空闲房间
export const GetBusinessRoomFreeRoomscale = virtualRoomScaleId => API.GET(`/api/business/room/free/roomscale/${virtualRoomScaleId}`, true)
// 查询酒店房间电量
export const GetBusinessRoomAmmeterRecordByhotel = data => API.GET(`/api/business/room/ammeter/record/byhotel`, data, true)
// 根据ID删除记录
export const PostBusinessRoomAmmeterRecordRemove = roomAmmeterRecordId => API.POST(`/api/business/room/ammeter/record/remove/${roomAmmeterRecordId}`, true)


/******************************  roomchange  *******************************/
// 删除房型映射
export const GetBusinessRoomchangeRecord = orderRoomId => API.GET(`/api/business/roomchange/record/${orderRoomId}`, true)


/******************************  month  *******************************/
// 账单管理-查询账单列表-长租
export const GetBusinessMonthBillRecord = (hotelId,data) => API.GET(`/api/business/month/bill/record/${hotelId}`,data, true)
// 账单管理-账单转账失败-长租
export const GetBusinessMonthBillRecordTransfer = monthBillRecordId => API.GET(`/api/business/month/bill/record/transfer/${monthBillRecordId}`, true)
// 查询长租账单明细-长租
export const GetBusinessMonthBillRecordList = monthBillRecordId => API.GET(`/api/business/month/bill/record/list/${monthBillRecordId}`, true)


/******************************  renewal  *******************************/
// 续签合同
export const GetBusinessRenewalContractAdd = data => API.GET(`/api/business/renewal/contract/add`, data, true)
// 根据订单房间查询合同
export const GetBusinessRenewalContractByOrderRoom = orderRoomId => API.GET(`/api/business/renewal/contract/byOrderRoom/${orderRoomId}`, true)
// 根据订单房间查询最后一次合同
export const GetBusinessRenewalContractLastByOrderRoom = orderRoomId => API.GET(`/api/business/renewal/contract/last/byOrderRoom/${orderRoomId}`, true)


/******************************  deposit  *******************************/
// 根据订单房间查询扣押记录
export const GetBusinessDepositCutRecordByorderroom = orderRoomId => API.GET(`/api/business/deposit/cut/record/byorderroom/${orderRoomId}`, true)


/******************************  reverse  *******************************/
// 根据订单房间获取冲账记录列表
export const GetBusinessReverseRecordByorderroom = data => API.GET(`/api/business/reverse/record/byorderroom/${data.orderRoomId}`, data, true)











// WEBPACK FOOTER //
// ./src/api/api_business_hotel_and_scale.js